import $ from 'jquery'
import ExcelModal from '@/views/parametres/import-excel-modal'
import ExclusionsDuree from '@/views/parametres/assurances/exclusions-duree/exclusions-duree.vue'
import AnnuaireAssurances from './annuaire-assurances.vue'

export default {
	name: 'assurances',
	components: {
		ExcelModal, ExclusionsDuree, AnnuaireAssurances
	},
	props: [],
	data() {
		return {
			user_role: '',           //  Role d'un utilisateur

			is_empty: false,
			is_loading: true,

			// Tel input placeholder config
            options: { placeholder: "Ex. 90 00 00 00", maxlength: 11 },
            tel_is_required: false,
			country_code: '',

			prefered_countries: [this.default_country_code],
            only_countries: ['tg', 'bj', 'ci', 'bf'],

			// Onglet affiché : compagnies d'assurances ou sociétés à convention directe (04/10/2026).
			onglet: 'assurance',
			compagnie: {
				compagnie_id: 0,
				nom: '',
				code_tel: '',
				telephone: '',
				email: '',
				adresse: '',
				type_tiers: 'assurance',
				is_edit: 0,
				// Création d'une société à convention : son contrat (04/10/2026).
				contrat_date_effet: '', contrat_date_expire: '', contrat_sans_fin: false, contrat_taux: ''
			},
			contrat_erreur: '',
			save_loading: false,
			btn_disable: false,

			compagnie_to_be_deleted: [],
            del_loading: false,
            is_confirm: false,

			// Groupe assurance
			groupe_assur: '',
			groupe_assur_id: 0,
			grp_loading: true,
			grp_is_empty: false,
			groupe_to_be_deleted: [],

			grp_fields: ['groupes', {key: 'default', label: 'Base'}, 'actif', 'actions'],
			grp_per_page: 5,
			is_list_group: true,

			g_default: '',
			g_actif: '',
			type_import: '',
			designation: '',
			emit_action: '',
			modal_toggler: true,

			assur_loading_percentage: 0,
            can_view_percentage: false,
            assur_refresh_timeout_id: null,
            countdown_seconds_left: 0,
            countdown_interval_id: null,
		}
	},

	watch: {
		g_default() {
			this.changeDefaultBase('default', this.g_default)
		},

		g_actif() {
			this.changeDefaultBase('actif', this.g_actif)
		}
	},

	computed: {
		compagnie_assurances() {
            return this.$store.getters["compagnie_assurances"];
        },

		fiches() {
			return this.compagnie_assurances.filter(fiche => (fiche.type_tiers === 'convention' ? 'convention' : 'assurance') === this.onglet);
		},

		titreFenetre() {
			const convention = this.compagnie.type_tiers === 'convention';
			if (this.compagnie.is_edit == 1) return convention ? 'Modifier la société à convention directe' : 'Modifier la compagnie d’assurances';
			return convention ? 'Nouvelle société à convention directe' : 'Nouvelle compagnie d’assurances';
		},
	},

	mounted() {
		this.fetchListeAssurances()
	},

	beforeDestroy() {
        if (this.assur_refresh_timeout_id) {
            clearTimeout(this.assur_refresh_timeout_id)
            this.assur_refresh_timeout_id = null
        }

        if (this.countdown_interval_id) {
            clearInterval(this.countdown_interval_id)
            this.countdown_interval_id = null
        }
    },

	methods: {
		countdownLoad() {
            const TOTAL_SECONDS = 4 * 60

            if (this.countdown_interval_id) {
                clearInterval(this.countdown_interval_id)
                this.countdown_interval_id = null
            }

            this.countdown_seconds_left = TOTAL_SECONDS
            // Initialize percentage based on full remaining time
            this.assur_loading_percentage = 100

            this.countdown_interval_id = setInterval(() => {
                if (this.countdown_seconds_left > 0) {
                    this.countdown_seconds_left--
                    // Update loading percentage according to remaining time
                    this.assur_loading_percentage = (this.countdown_seconds_left / TOTAL_SECONDS) * 100
                } else {
                    clearInterval(this.countdown_interval_id)
                    this.countdown_interval_id = null
                    this.assur_loading_percentage = 0
                }
            }, 1000)
        },

		refreshListeAssurance() {
            this.is_loading = true
            this.can_view_percentage = true
            if (this.assur_refresh_timeout_id) {
                clearTimeout(this.assur_refresh_timeout_id)
                this.assur_refresh_timeout_id = null
            }

            if (this.compagnie_assurances.length > 0) {
                this.countdown_seconds_left = 0
            }

            if (this.countdown_seconds_left == 0 ) {
                this.can_view_percentage = false
                this.fetchListeAssurances()
                return
            }

            // Re-fetch then retry after 5s until counts match
            this.fetchListeAssurances()
            this.assur_refresh_timeout_id = setTimeout(() => {
                this.refreshListeAssurance()
            }, 5000)
        },

		loadEmitAction() {
            this.countdownLoad()
            this.refreshListeAssurance()
        },

		fetchListeAssurances() {
			this.is_loading = true

			this.$store.dispatch("getAssurance").then(() => {
				if(this.compagnie_assurances.length > 0) {
					this.is_empty = false
				} else {
					this.is_empty = true
				}

				if (this.can_view_percentage) {
                    if (this.countdown_seconds_left == 0) {
                        this.is_loading = false
                    }
                } else {
                    this.is_loading = false
                }
			});
		},

		clearError() {
			for (let i = 1; i <= 4; i++) {
				$('.err-msg-'+i).fadeOut(500)
			}
		},

		nombreParType(type) {
			return this.compagnie_assurances.filter(fiche => (fiche.type_tiers === 'convention' ? 'convention' : 'assurance') === type).length
		},

		changerOnglet(type) {
			this.onglet = type
		},

		ouvrirModification(fiche) {
			this.edit(fiche)
			$(this.$refs.modalAssurance).modal('show')
		},

		ouvrirSuppression(fiche) {
			this.remove(fiche)
			$(this.$el).find('.delete').modal('show')
		},

		// La création suit l'onglet ouvert : compagnie d'assurances ou société à convention directe.
		nouvelleFiche() {
			this.clearError()
			this.contrat_erreur = ''
			this.compagnie = { compagnie_id: 0, nom: '', code_tel: '', telephone: '', email: '', adresse: '', type_tiers: this.onglet, is_edit: 0,
				contrat_date_effet: '', contrat_date_expire: '', contrat_sans_fin: false, contrat_taux: '' }
		},

		changeDefaultBase(type_config, groupe_id) {
			let data = {
				type_config: type_config,
				groupe_id: groupe_id
			}

			this.$store.dispatch('configBaseActifAssurance', data)
		},

		basculerSansFin() {
			if (this.compagnie.contrat_sans_fin) this.compagnie.contrat_date_expire = ''
		},

		verifierContrat() {
			const c = this.compagnie
			if (!c.contrat_date_effet) return 'Renseignez la date d’effet du contrat.'
			if (!c.contrat_sans_fin && !c.contrat_date_expire) return 'Renseignez la date de fin ou cochez « Sans date de fin ».'
			if (!c.contrat_sans_fin && c.contrat_date_expire < c.contrat_date_effet) return 'La date de fin doit suivre la date d’effet.'
			if (!/^\d+$/.test(String(c.contrat_taux)) || Number(c.contrat_taux) > 100) return 'Le taux de prise en charge est un nombre entier de 0 à 100 %.'
			return ''
		},

		countryChanged(country) {
            this.compagnie.code_tel = '+'+country.dialCode
        },

		async submit() {
			const isValid = await this.$refs.observer.validate();

            if (!isValid) {
                return;
            }

			// Société à convention créée avec son contrat ; on ouvre ensuite sa page (04/10/2026).
			const nouvelleConvention = this.compagnie.type_tiers === 'convention' && this.compagnie.is_edit == 0
			this.contrat_erreur = nouvelleConvention ? this.verifierContrat() : ''
			if (this.contrat_erreur) {
				return;
			}
			const info = this.$store.getters['authInfo']
			const donnees = Object.assign({}, this.compagnie, { user_id: info ? info.id : 0 })

            this.save_loading = true
            this.btn_disable = true

            this.$store.dispatch("addAssurance", donnees).then((response) => {
                if (response > 0) {
                    this.fetchListeAssurances();

					
					const libelle = this.compagnie.type_tiers === 'convention' ? 'Société à convention directe' : 'Compagnie d\'assurances'
					this.successMsg(libelle + (this.compagnie.is_edit == 0 ? ' ajoutée avec succès' : ' modifiée avec succès'))
					// La fiche enregistrée s'affiche dans son onglet.
					this.onglet = this.compagnie.type_tiers === 'convention' ? 'convention' : 'assurance'
					$('.modal').modal('hide')

                    this.compagnie = {
						compagnie_id: 0,
						nom: '',
						code_tel: '',
						telephone: '',
						email: '',
						adresse: '',
						type_tiers: this.onglet,
						is_edit: 0,
						contrat_date_effet: '', contrat_date_expire: '', contrat_sans_fin: false, contrat_taux: ''
					}
					if (nouvelleConvention && this.$router) this.$router.push('/parametres/assureur/' + response)
					
					
                } else {
					if (response == -1) {
						$('.err-msg-1').fadeIn(500)
					} else if (response == -2) {
						$('.err-msg-2').fadeIn(500)
					} else if (response == -3) {
						$('.err-msg-3').fadeIn(500)
					} else if (response == -4) {
						$('.err-msg-4').fadeIn(500)
					} else if (response == -5) {
						this.contrat_erreur = 'Contrat invalide : vérifiez les dates et le taux (0 à 100 %).'
					}
                }
				this.save_loading = false
                this.btn_disable = false
            })
		},

		successMsg: function(message) {
            this.$toasted.show(message, {
                duration: 3000,
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                theme: 'toasted-primary',
                type: 'success',
                position: 'top-center'

            })
        },

		doErrorMsg: function(message) {
            this.$toasted.show(message, {
                duration: 3000,
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                position: 'top-center',
                theme: 'toasted-primary',
                type: 'error'

            })
        },

		/**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

		remove(data) {
			this.compagnie_to_be_deleted = {
                id: data.id,
                compagnie: data.compagnie_assurance,
            }
		},

		edit (data) {
			let phone_number = ''
			if (data.telephone != '' && data.telephone != null) {
				phone_number = data.telephone.split("+228").pop()
			} 
			
			this.compagnie = {
				compagnie_id: data.id,
				nom: data.compagnie_assurance,
				code_tel: '',
				telephone: phone_number,
				email: data.email,
				adresse: data.adresse,
				type_tiers: data.type_tiers === 'convention' ? 'convention' : 'assurance',
				is_edit: 1,
				contrat_date_effet: '', contrat_date_expire: '', contrat_sans_fin: false, contrat_taux: ''
			}
		},

		/**
		 * Retirer un examen de la liste de demande
		 */
        supprimer() {
            this.del_loading = true;

            let confirm = document.getElementById('cfrm-del');
            let err = 0

            if (confirm.checked == false) { //  Vérifie si l'utilisateur a confirmé la cloture
                $('.err-msg').fadeIn(500)
                err++;
                this.del_loading = false;
            }

            if (err == 0) {
                this.$store.dispatch('deleteCompagnie', this.compagnie_to_be_deleted).then((response) => {
                    console.log("DEL repsonse : ", response)
                    if (response > 0) {
                        this.successMsg('Compagnie d\'assurance supprimé avec succès')
                    }

					this.fetchListeAssurances();
					$('.modal').modal('hide')
                    this.del_loading = false;
                    this.is_confirm = false
                    
                })
            }
        },

		backToList() {
			$('.new-group').fadeOut(500)
			setTimeout(() => {
				$('.list-group').fadeIn()
			}, 500);
			this.is_list_group = true
		},

		importExcelFile(type_import, designation) {
            this.type_import = type_import
            this.designation = designation
            this.modal_toggler = (this.modal_toggler)?false:true

            this.emit_action = 'emitListAssurance'

            setTimeout(() => {
                $('.excel-modal-'+type_import).modal('show')
            }, 200);
        },
	}
}
